"use client";

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { cn } from "lib/utils";
import { newDashboardListOfLinks } from "constants/global";
import { VectorIconRight } from "asset/icons";
import { Clock, SidebarLeft } from "iconsax-reactjs";
import TradevuLogo from "../TradevuLogo";

const NewSideNav = ({ isCollapsed, toggleNav, isMobile = false }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    return isMobile ? (
        <>
            <div className="flex items-center justify-between w-full pt-[5px]">
                <Link
                    href="/"
                    className={cn(
                        "flex items-center w-full"
                    )}
                >
                    <TradevuLogo />
                </Link>
            </div>

            <div
                className={cn(
                    "w-full h-[85vh] overflow-x-hidden scroll-smooth no-scrollbar overflow-y-auto pr-1",
                    !isCollapsed ? "mt-6" : "mt-10"
                )}
            >
                {Object.entries(newDashboardListOfLinks).map(([title, links], index) => {
                    const isLastItem = title === "TREASURY";
                    return (
                        <div
                            key={index}
                            className={cn(
                                title !== "FIRST" ? "mt-4 mb-4" : "",
                                !isCollapsed ? "my-0" : "",
                                "mb-4"
                            )}
                        >
                            {title !== "FIRST" && (
                                <h3
                                    className={cn(
                                        "inline-flex gap-3 pl-6 mb-3 text-xs items-center font-medium text-gray-80 xl:flex",
                                        !isCollapsed && "lg:hidden"
                                    )}
                                >
                                    <span>{title}</span>{" "}
                                    {isLastItem && (
                                        <span className="px-[10px] py-[3px] text-xs font-light rounded-full bg-secondary-10 !text-secondary">
                                            Coming soon
                                        </span>
                                    )}
                                </h3>
                            )}
                            <div className="relative flex flex-col">
                                {links.map(({ text, icon, link, comingSoon, children }, i) => {
                                    const isActive =
                                        pathname === link || pathname === link?.split("?")[0];
                                    return (
                                        <div key={i}>
                                            <button
                                                disabled={comingSoon || isLastItem}
                                                onClick={() => {
                                                    navigate(link);
                                                }}
                                                style={{
                                                    boxShadow: isActive
                                                        ? "0px 1px 4px -2px #9295B466"
                                                        : "none",
                                                }}
                                                className={cn(
                                                    "flex items-center relative transition-all ease-in w-full px-4 h-[44px] py-2 rounded-lg !outline-0 !ring-0 focus:!ring-0 focus:!outline-0 active:!ring-0 active:!outline-0",
                                                    comingSoon || isLastItem
                                                        ? "text-gray-80 font-[350] cursor-not-allowed"
                                                        : isActive
                                                        ? "bg-white border hover:!border-[1.5px] shadow-2xs !border-[#EBEDF9] hover:!shadow-[0px_1px_4px_-4px_rgba(20,20,20,0.16)]"
                                                        : "bg-transparent hover:!bg-[#E1E3F44D]",
                                                    !isCollapsed
                                                        ? "px-2 justify-center"
                                                        : "px-4 justify-start"
                                                )}
                                            >
                                                {icon?.(
                                                    comingSoon || isLastItem
                                                        ? "Outline"
                                                        : isActive
                                                        ? "Bold"
                                                        : "Outline",
                                                    comingSoon
                                                        ? "#9396B4"
                                                        : isActive
                                                        ? "#6F00FF"
                                                        : "#6F739B"
                                                )}
                                                <span
                                                    className={cn(
                                                        "inline-flex text-sm lg:text-xs lg:whitespace-nowrap xl:text-sm w-full pl-2 ",
                                                        comingSoon || isLastItem
                                                            ? "text-gray-80 font-[350] cursor-not-allowed"
                                                            : isActive
                                                            ? "!text-secondary font-[450]"
                                                            : "text-gray-70 font-[350]",
                                                        !isCollapsed && "lg:hidden xl:inline-flex"
                                                    )}
                                                >
                                                    {text}
                                                </span>
                                                {isActive && (
                                                    <span className="block lg:hidden xl:flex w-1 rounded-md ml:auto h-4/6 !bg-secondary"></span>
                                                )}
                                                {comingSoon ? (
                                                    <div className="block lg:hidden xl:flex absolute right-3 items-center px-[10px] py-1 rounded-xl bg-secondary-30 justify-normal">
                                                        <Clock size={14} color="#9396B4" />
                                                    </div>
                                                ) : null}
                                            </button>
                                            {(isActive || children?.[0].link === pathname) &&
                                                children?.map(({ text, link }, index) => {
                                                    const isChildActive = pathname === link;
                                                    return (
                                                        <button
                                                            key={index + text}
                                                            onClick={() => {
                                                                navigate(link);
                                                            }}
                                                            className={cn(
                                                                "relative h-[39px] flex mb-2 items-cente justify-start gap-3 pl-8 xl:text-sm text-sm lg:text-xs",
                                                                isChildActive
                                                                    ? "!text-secondary font-[350]"
                                                                    : "text-gray-70 font-[350]"
                                                            )}
                                                        >
                                                            <VectorIconRight className="h-7" />
                                                            <span className="relative top-4">
                                                                {text}
                                                            </span>
                                                        </button>
                                                    );
                                                })}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    ) : (
        <>
            <div
                className={cn(
                    "flex items-end w-full pt-[5px]",
                    isCollapsed ? "justify-between pr-1" : "justify-between pl-4"
                )}
            >
                <div
                    className={cn(
                        "flex items-center",
                        isCollapsed ? "pl-5 justify-start" : "justify-start"
                    )}
                >
                    <Link href="/">
                        {!isCollapsed ? <TradevuLogo smallLogo={true} /> : <TradevuLogo />}
                    </Link>
                </div>
                <SidebarLeft
                    onClick={() => {
                        toggleNav?.();
                    }}
                    size={19}
                    className={cn(
                        "text-[#6F739B] cursor-pointer",
                        isCollapsed ? "scale-x-[1]" : "scale-x-[-1]"
                    )}
                />
            </div>

            <div
                className={cn(
                    "w-full h-[85vh] scroll-smooth no-scrollbar overflow-x-hidden overflow-y-auto pr-1",
                    !isCollapsed ? "mt-6 flex flex-col items-center" : "mt-10"
                )}
            >
                {Object.entries(newDashboardListOfLinks).map(([title, links], index) => {
                    const isLastItem = title === "CAPITAL";
                    const isFinance = title === "FINANCE";
                    return (
                        <div
                            key={index}
                            className={cn(
                                title !== "FIRST" ? "mt-4 mb-4" : "",
                                !isCollapsed ? "my-0" : "",
                                "mb-4",
                                isFinance ? "first-step" : "",
                            )}
                        >
                            {title !== "FIRST" && (
                                <h3
                                    className={cn(
                                        "inline-flex gap-3 mb-3 pl-6 text-xs  items-center font-medium text-gray-80 xl:flex",
                                        !isCollapsed ? "lg:hidden pl-0 text-center" : ""
                                    )}
                                >
                                    <span className="w-full">{title}</span>{" "}
                                    {isLastItem && isCollapsed && (
                                        <span className="px-[10px] w-full truncate py-[3px] text-xs font-light rounded-full bg-secondary-10 !text-secondary">
                                            Coming soon
                                        </span>
                                    )}
                                </h3>
                            )}
                            <div className="relative flex flex-col">
                                {links.map(({ text, icon, link, comingSoon, children }, i) => {
                                    const isActive =
                                        pathname === link || pathname === link?.split("?")[0];
                                    return (
                                        <div key={i}>
                                            <button
                                                disabled={comingSoon || isLastItem}
                                                onClick={() => {
                                                    navigate(link);
                                                }}
                                                style={{
                                                    boxShadow: isActive
                                                        ? "0px 1px 4px -2px #9295B466"
                                                        : "none",
                                                }}
                                                className={cn(
                                                    "flex items-center relative transition-all ease-in w-full px-4 py-2 rounded-lg !outline-0 !ring-0 focus:!ring-0 focus:!outline-0 active:!ring-0 active:!outline-0",
                                                    comingSoon || isLastItem
                                                        ? "text-gray-80 opacity-8 font-[350] cursor-not-allowed"
                                                        : isActive
                                                        ? "bg-white border hover:!border-[1.5px] shadow-2xs !border-[#EBEDF9] hover:!shadow-[0px_1px_4px_-4px_rgba(20,20,20,0.16)]"
                                                        : "bg-transparent hover:!bg-[#E1E3F44D]",
                                                    !isCollapsed
                                                        ? "px-2 justify-center items-center flex-col size-[56px]"
                                                        : "px-4 justify-start h-[44px]"
                                                )}
                                            >
                                                {icon?.(
                                                    comingSoon || isLastItem
                                                        ? "Outline"
                                                        : isActive
                                                        ? "Bold"
                                                        : "Outline",
                                                    comingSoon
                                                        ? "#9396B4"
                                                        : isActive
                                                        ? "#6F00FF"
                                                        : "#6F739B"
                                                )}
                                                <span
                                                    className={cn(
                                                        "text-sm lg:text-xs lg:whitespace-nowrap xl:text-sm w-full",
                                                        comingSoon || isLastItem
                                                            ? "text-gray-80 font-[350] cursor-not-allowed"
                                                            : isActive
                                                            ? "!text-secondary font-[450]"
                                                            : "text-gray-70 font-[350]",
                                                        !isCollapsed
                                                            ? "xl:text-[10px] xl:w-[100%] xl:truncate xl:text-center"
                                                            : "pl-2 text-left"
                                                    )}
                                                >
                                                    {text}
                                                </span>
                                                {isActive && isCollapsed && (
                                                    <span className="block lg:hidden xl:flex w-1 rounded-md ml:auto h-4/6 !bg-secondary"></span>
                                                )}
                                                {isLastItem && isCollapsed ? null : comingSoon ? (
                                                    <div
                                                        className={cn(
                                                            "block absolute lg:flex items-center px-[8px] py-[2px] rounded-xl bg-secondary-30 justify-normal",
                                                            !isCollapsed
                                                                ? "top-0 -right-1 !bg-[#EBE4FF]"
                                                                : "border right-0 "
                                                        )}
                                                    >
                                                        <Clock size={14} color="#9396B4" />
                                                    </div>
                                                ) : null}
                                            </button>
                                            {!isCollapsed
                                                ? null
                                                : (isActive || children?.[0].link === pathname) &&
                                                  children?.map(({ text, link }, index) => {
                                                      const isChildActive = pathname === link;
                                                      return (
                                                          <button
                                                              key={index + text}
                                                              onClick={() => {
                                                                  navigate(link);
                                                              }}
                                                              className={cn(
                                                                  "relative h-[39px] flex mb-2 items-cente justify-start gap-3 pl-8 xl:text-sm text-sm lg:text-xs",
                                                                  isChildActive
                                                                      ? "!text-secondary font-[350]"
                                                                      : "text-gray-70 font-[350]"
                                                              )}
                                                          >
                                                              <VectorIconRight className="h-7" />
                                                              <span className="relative top-4">
                                                                  {text}
                                                              </span>
                                                          </button>
                                                      );
                                                  })}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default NewSideNav;
